import { Platform } from 'react-native';
import { useResponsiveLayout } from './useResponsiveLayout';

export type Density = 'regular' | 'compact';

/**
 * Pointer-driven desktop web gets denser paddings; touch stays regular.
 * Density never invents new spacing values — consumers map one step down
 * the existing 4px-grid tokens (md→smd for card/list padding, lg→md for
 * screen gutters). `regular` is the pre-shell values, so mobile/native
 * layouts are untouched by definition.
 */
export function useDensity(): Density {
  const { isDesktop } = useResponsiveLayout();
  return Platform.OS === 'web' && isDesktop ? 'compact' : 'regular';
}
